module.exports = __webpack_public_path__ + "static/Mango-a8ad4715addaa820f7372573f16ab6bd.png";